import React from 'react';
import PageLayout from '../components/PageLayout';

/**
 * Help Center page component
 */
const HelpCenterPage: React.FC = () => {
  return (
    <PageLayout 
      title="Help Center" 
      subtitle="Find answers to common questions and get support"
      backgroundImage="https://images.pexels.com/photos/6580604/pexels-photo-6580604.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
    >
      <section>
        <h2>Frequently Asked Questions</h2>
        
        <div className="content-card">
          <h3>Booking Questions</h3>
          
          <div style={{ marginBottom: '1.5rem' }}>
            <h4>How do I book a tee time?</h4>
            <p>
              Booking a tee time is easy! Simply select a golf course, choose your preferred date, 
              and select an available time slot. Then enter your information, specify the number of 
              players, and complete the booking process.
            </p>
          </div>
          
          <div style={{ marginBottom: '1.5rem' }}>
            <h4>Can I book for multiple players?</h4>
            <p>
              Yes! You can book for up to 4 players per tee time. You'll need to provide basic 
              information for each player during the booking process.
            </p>
          </div>
          
          <div style={{ marginBottom: '1.5rem' }}>
            <h4>How far in advance can I book?</h4>
            <p>
              Most courses allow bookings up to 14 days in advance, though some premium courses 
              may offer longer booking windows.
            </p>
          </div>
          
          <div>
            <h4>What is your cancellation policy?</h4>
            <p>
              Cancellation policies vary by course. Generally, cancellations made more than 24 hours 
              in advance receive a full refund, while later cancellations may incur a fee. You can view 
              the specific policy for each course during the booking process.
            </p>
          </div>
        </div>
        
        <div className="content-card" style={{ marginTop: '2rem' }}>
          <h3>Account Management</h3>
          
          <div style={{ marginBottom: '1.5rem' }}>
            <h4>How do I create an account?</h4>
            <p>
              Click the "Sign Up" button in the top right corner of any page. You'll need to provide 
              your name, email address, and create a password.
            </p>
          </div>
          
          <div style={{ marginBottom: '1.5rem' }}>
            <h4>How do I view my bookings?</h4>
            <p>
              Once logged in, you can view all your upcoming and past bookings in the "My Bookings" 
              section, accessible from the main navigation.
            </p>
          </div>
          
          <div>
            <h4>Is my payment information secure?</h4>
            <p>
              Yes, we use industry-standard encryption to protect your payment information. We never 
              store complete credit card details on our servers.
            </p>
          </div>
        </div>
      </section>
      
      <section>
        <h2>Contact Support</h2>
        <div className="two-column-content">
          <div className="content-card">
            <h3>Support Options</h3>
            <p><strong>Email:</strong> support@golfscape.com</p>
            <p><strong>Phone:</strong> (555) 123-4567</p>
            <p><strong>Hours:</strong> Monday - Friday: 8am - 8pm ET<br />Saturday - Sunday: 9am - 5pm ET</p>
            <p>
              Our support team is dedicated to providing quick, helpful assistance. For the fastest 
              response, please include your booking ID (if applicable) and any relevant screenshots.
            </p>
          </div>
          
          <div className="content-card">
            <h3>Send a Message</h3>
            <form className="contact-form" style={{ padding: 0, boxShadow: 'none' }}>
              <div className="form-group">
                <label htmlFor="name">Your Name</label>
                <input type="text" id="name" placeholder="John Smith" />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input type="email" id="email" placeholder="your.email@example.com" />
              </div>
              
              <div className="form-group">
                <label htmlFor="subject">Issue Type</label>
                <select id="subject">
                  <option value="">Select an issue</option>
                  <option value="booking">Booking Problem</option>
                  <option value="account">Account Issue</option>
                  <option value="payment">Payment Question</option>
                  <option value="technical">Technical Support</option>
                  <option value="other">Other</option>
                </select>
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Your Message</label>
                <textarea id="message" rows={4} placeholder="Please describe your issue"></textarea>
              </div>
              
              <button type="submit" className="form-submit">Send Message</button>
            </form>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default HelpCenterPage;
